<section class="container-global">

  <div class="grille-sections" *ngIf="products && hasProducts">

    <!-- Products -->
    <div class="bloc-section" [ngClass]="getThemeClass(category)" *ngFor="let category of productCategories">
      <div class="header-section">
        <h2 class="titre-section">{{ getTypeName(category) || 'En ce moment' }}</h2>
      </div>

      <div class="carousel-wrapper">
        <button *ngIf="products[category].length > 0" (click)="scrollListe(productList, 'gauche')" class="nav-arrow prev desktop-arrow">
          <i class="fa fa-chevron-left"></i>
        </button>

        <div class="liste-produits-scroll" #productList #listeRef (scroll)="gererScrollInfini($event)">
          <div class="carte-produit" *ngFor="let product of products[category]">
            <a [routerLink]="route.parse('product', [$any(product).ident])" class="lien-produit-global">

              <div class="visuel-boite">
                <img [src]="imageErrors[product.ident] ? 'assets/img/logo/logo.png' : getProductImage(product)" (error)="onImageError(product.ident)" [alt]="product.name">

                <div class="bandeau-rupture" *ngIf="$any(product).state == 'rupture'">
                  Rupture
                </div>
              </div>

              <div class="btn-pillule">
                <div class="col-info">
                  <span class="nom">{{ product.name }}</span>
                  <span class="prix" *ngIf="product | getPrices:0">{{product | getPrices:0 | formatPrice}}€</span>
                </div>

                <div class="btn-cart" *ngIf="$any(product).state != 'rupture'" (click)="addToCart(product); $event.stopPropagation(); $event.preventDefault()">
                  <i class="fa fa-shopping-cart"></i>
                </div>

                <div class="btn-cart btn-alert" *ngIf="$any(product).state == 'rupture'" (click)="openAlertModal(product); $event.stopPropagation(); $event.preventDefault()">
                  <i class="fa-regular fa-bell"></i>
                </div>
              </div>

            </a>
          </div>
        </div>

        <button *ngIf="products[category].length > 0" (click)="scrollListe(productList, 'droite')" class="nav-arrow next desktop-arrow">
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>

      <a [routerLink]="route.parse('products-list', getFilterRoute(category))" class="lien-bas">
        {{ (getSeeAll(category) || 'Voir tout') }} >
      </a>
    </div>

  </div>
</section>

<gob-alert-modal
  *ngIf="selectedProduct"
  [isOpen]="isAlertOpen"
  [productName]="selectedProduct.name"
  [productId]="selectedProduct.ident"
  (closeEvent)="isAlertOpen = false; selectedProduct = null">
</gob-alert-modal>
